import { useMemo } from "react";
import Layout from "@/components/Layout";
import HeroSection from "@/components/HeroSection";
import ValuePropsGrid from "@/components/ValuePropsGrid";
import HowItWorks from "@/components/HowItWorks";
import GivingBackTeaser from "@/components/GivingBackTeaser";
import { useSEO } from "@/hooks/useSEO";
import { JsonLd } from "@/components/JsonLd";
import { buildFaqSchema, ORGANIZATION_SCHEMA, WEBSITE_SCHEMA } from "@/lib/structuredData";

const Index = () => {
  useSEO({
    title: "Hintsly — Give the Gift They'll Actually Love | Free Australian Gift Registry",
    description: "Tired of fake smiles and unwanted gifts? Hintsly is a free Australian wishlist that works with any store. Build your list, share the hint, and get gifts you'll genuinely love.",
    canonical: "https://hintsly.com.au/",
    ogImage: "https://storage.googleapis.com/gpt-engineer-file-uploads/oJjC56Ppnuenr66HUKHlXSAqc4b2/social-images/social-1773677775251-Untitled_2.webp",
  });

  const faqSchema = useMemo(
    () =>
      buildFaqSchema([
        {
          question: "What is Hintsly?",
          answer:
            "Hintsly is a free Australian gift registry and wishlist platform that works with any store. Create your wishlist, share the link with friends and family, and get gifts you'll genuinely love.",
        },
        {
          question: "Is Hintsly free to use?",
          answer:
            "Yes! Creating wishlists, sharing them, and claiming gifts is completely free. We only charge small fees on optional cash fund contributions and charity donations to cover payment processing.",
        },
        {
          question: "How does Hintsly reduce gift waste?",
          answer:
            "By letting recipients choose exactly what they want, Hintsly eliminates unwanted gifts that end up in landfill. Australians waste over $1.3 billion on unwanted gifts each year — Hintsly helps fix that.",
        },
        {
          question: "Can I add items from any store?",
          answer:
            "Yes! Hintsly works with any online store. Simply paste a product URL or add items manually. There are no store restrictions.",
        },
        {
          question: "How do I share my wishlist?",
          answer:
            "After creating your wishlist, click 'Share the hint' to get a unique link. Share it via text, email, WhatsApp, Facebook, or any messaging app.",
        },
      ]),
    []
  );

  return (
    <Layout>
      <JsonLd data={faqSchema} />
      <JsonLd data={ORGANIZATION_SCHEMA as Record<string, unknown>} />
      <JsonLd data={WEBSITE_SCHEMA as Record<string, unknown>} />
      <HeroSection />
      <ValuePropsGrid />
      <HowItWorks />
      <GivingBackTeaser />
    </Layout>
  );
};

export default Index;
